import "ng-image-input-with-preview/dist/ng-image-input-with-preview.js";

export default 'ngImageInputWithPreview';